<script>
    import StarRating from 'vue-star-rating';
    import vSelect from 'vue-select';
    import UnbounceConfirmRegistrationModal from './partials/UnbounceConfirmRegistrationModal'
    import CompanyPromotionModal from './partials/PromotionModal'

    export default {
        components: {
          StarRating,
          UnbounceConfirmRegistrationModal,
          CompanyPromotionModal,
          'v-select': vSelect
        },
        name: 'Dashboard',
        props: ['companyprop', 'medalsprop', 'cookieprop'],
        data() {
            return {
                company: {},
                number_of_medals: 0,
                modalInitialState: 1
            }
        },
        mounted() {
            var self = this;
            this.company = this.companyprop;
            this.$bus.$on('contracts_accepted', function (args) {
                self.company.accept_payments = 1;
            });

            $('#gift-modal-2').on('hidden.bs.modal', function () {
                self.updateContractsMedals();
            });
            $("#confirmRegistration").modal({
                backdrop: 'static',
                keyboard: false,
                show: false
            })
//console.log('companyprop', this.companyprop.phone_number, typeof this.companyprop.phone_number)
            if (!_.isUndefined(this.cookieprop)) {
                if (!_.isArray(this.cookieprop) && !this.cookieprop.status) {
                    $("#confirmRegistration").modal('show')
                } else if (!this.companyprop.phone_number) {
                    $("#confirmRegistration").modal('show')
                    this.modalInitialState = 3
                }
            }
        },
        methods: {
            onShowSmartModal() {
                this.$bus.$emit('course-modal.show', {
                    company: this.company
                })
                
                $("#course-smart-modal").modal('show')
            },            
            goToEvents() {
                return window.location.href = route('companies.dashboard.event-reservations', this.company.slug)
            },
            goToSummerCampStart(){
                return window.location.href = '/campi-estivi/' + this.company.slug + '/start';
            },
            goToMarketingServices() {
                window.open('https://sportclub.orangogo.it/servizi-marketing-digitale', '_blank')
            },
            goToDownloadCoupons() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/scarica-buoni'
            },
            goToBackendVouchers() {
                window.open(route('companies.dashboard.vouchers', this.company.slug), '_blank')
                /*return window.location.href = route('companies.dashboard.vouchers', this.company.slug)*/
            },
            goToVouchers() {
                return window.location.href = route('companies.dashboard.internal-vouchers', this.company.slug)
            },
            goToValidatedVouchers() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/voucher-validati'
            },
            goToReservations() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/prenotazioni'
            },
            goToRequests() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/richieste'
            },
            goToCourses() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/corsi'
            },
            goToWidget() {
                location.href = route('companies.dashboard.widget', this.company.slug)
            },
            goToByScroll(id) {
                $('html,body').animate({
                    scrollTop: $("#" + id).offset().top
                }, 'slow');
            },
            onAcceptSummerCampsNotification(company){

                axios({
                    method: 'put',
                    url: '/companies/' + company.id + '/summer',
                    data: {
                        accept: true
                    }
                }).then((response) => {
                    window.alerts.success('Sarai contattato presto.');
                }).catch((error) => {
                    this.$emit('init-error', 'Active failed');
                });
            },
            onDeclineSummerCampsNotification(company){

                axios({
                    method: 'put',
                    url: '/companies/' + company.id + '/summer',
                    data: {
                        accept: false
                    }
                }).then((response) => {
                    window.alerts.success('Ok, non sarai contattato.');
                }).catch((error) => {
                    this.$emit('init-error', 'Active failed');
                });
            }
        },
    }

</script>




// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/Dashboard.vue